import type { ReactNode } from 'react';

import { ReactComponent as Service } from '@quick/assets/icons/form/service.svg';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from '../FormDataContext';

import { CommonTitle } from './CommonTitle';

export function ServiceTitle({ children }: { children: ReactNode }) {
  const { t } = useAppTranslation(['demand']);
  const { line } = useFormDataContext();
  if (!line?.id) return null;
  return (
    <>
      <CommonTitle
        title={t('demand:service')}
        Icon={Service}
        className="col-span-full"
      />
      <div className="grid gap-x-4 gap-y-6 sm:grid-flow-col">{children}</div>
    </>
  );
}
